import React, { useEffect, useState } from "react";
import { Box, Checkbox, Typography } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";

export default function DataPrivacyPolicy({ updateDetails }) {
  const [checked, setChecked] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  useEffect(() => {
    if (checked) {
      updateDetails({ consent: "Agree" });
    } else {
      updateDetails({ consent: "Disagree" });
    }
  }, [checked]);

  return (
    <Box
      sx={{
        width: "100%",
        fontSize: { xs: "0.5rem" },
      }}
    >
      <Typography
        mb={2}
        sx={{
          fontSize: { xs: "0.7rem", xl: "1rem" },
          "@media (min-height: 1080px)": {
            fontSize: "1rem",
          },
        }}
      >
        The personal information included in this document shall only be used
        for the purposes of administering the survey and the determination of
        client`s satisfaction and feedback for better services. Any personal
        information included herein may not be used for other purposes aside
        from those stated above.
      </Typography>
      <Typography
        mb={2}
        sx={{
          fontSize: { xs: "0.7rem", xl: "1rem" },
          "@media (min-height: 1080px)": {
            fontSize: "1rem",
          },
        }}
      >
        (Ang personal na impormasyon sa dokumentong ito at maari lamang gamitin
        para sa layunin ng serbey na ito at para malaman ang kasiyahan at puna
        ng kliyente para sa ikabubuti ng mga serbisyo. Hindi ito maaring gamitin
        para sa iba pang layunin maliban sa nabanggit)
      </Typography>
      <Typography
        mb={2}
        sx={{
          fontSize: { xs: "0.7rem", xl: "1rem" },
          "@media (min-height: 1080px)": {
            fontSize: "1rem",
          },
        }}
      >
        Upon accomplishing this form, you are giving your consent to the use of
        your personal information for the purposes stated above.
      </Typography>
      <Typography
        mb={2}
        sx={{
          fontSize: { xs: "0.7rem", xl: "1rem" },
          "@media (min-height: 1080px)": {
            fontSize: "1rem",
          },
        }}
      >
        (Sa pagsagot dito, binibigyan mo ng pahintulot gamitin ang iyong
        personal na impormasyon para sa nabanggit na layunin.)
      </Typography>
      <Typography
        mb={2}
        sx={{
          fontSize: { xs: "0.7rem", xl: "1rem" },
          "@media (min-height: 1080px)": {
            fontSize: "1rem",
          },
        }}
      >
        Your experience matters to us!
      </Typography>
      <Typography
        sx={{
          fontSize: { xs: "0.7rem", xl: "1rem" },
          "@media (min-height: 1080px)": {
            fontSize: "1rem",
          },
        }}
      >
        (Ang iyong karanasan ay mahalaga sa amin!)
      </Typography>

      <Box
        sx={{
          mt: 5,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "@media (min-height: 1080px)": {
            mt: 10,
          },
        }}
      >
        <FormControlLabel
          control={<Checkbox checked={checked} onChange={handleChange} />}
          label="Agree"
          sx={{
            "& .MuiTypography-root": {
              fontSize: { xs: "0.7rem", xl: "1rem" },
              "@media (min-height: 1080px)": {
                fontSize: "1rem",
              },
            },
            mt: -5,
          }}
        />
      </Box>
    </Box>
  );
}
